import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio32 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.1992 9C17.1992 8.33726 16.6618 7.7998 15.999 7.7998H7.99902C7.33628 7.7998 6.79883 8.33726 6.79883 9V15C6.79883 15.6627 7.33628 16.2002 7.99902 16.2002H15.999C16.6618 16.2002 17.1992 15.6627 17.1992 15V9ZM18.7988 15C18.7988 16.5464 17.5454 17.7998 15.999 17.7998H7.99902C6.45263 17.7998 5.19922 16.5464 5.19922 15V9C5.19922 7.4536 6.45263 6.2002 7.99902 6.2002H15.999C17.5454 6.2002 18.7988 7.4536 18.7988 9V15Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio32);
export default ForwardRef;
